import React from 'react'
import { Form, Radio, Input } from 'antd'
import { AUDIENCE_OPTIONS } from './catalog'
import { MemberSelect } from './MemberSelect'

/**
 * Audience picker bound to a `{type, userIds?, classYear?}` value at `namePath`.
 * Reveals the member multi-select for 'members' and a year input for 'class_year'.
 */
export function AudienceField({ namePath }: { namePath: (string | number)[] }) {
  const form = Form.useFormInstance()
  const type = Form.useWatch([...namePath, 'type'], form) as string | undefined

  return (
    <>
      <Form.Item name={[...namePath, 'type']} initialValue="actor" style={{ marginBottom: 8 }}>
        <Radio.Group optionType="button" buttonStyle="solid" options={AUDIENCE_OPTIONS} />
      </Form.Item>
      {type === 'members' && (
        <Form.Item name={[...namePath, 'userIds']} rules={[{ required: true, message: 'Pick at least one member' }]}>
          <MemberSelect />
        </Form.Item>
      )}
      {type === 'class_year' && (
        <Form.Item name={[...namePath, 'classYear']} rules={[{ required: true, message: 'Enter a class year' }]}>
          <Input style={{ width: 160 }} placeholder="e.g. 2001" />
        </Form.Item>
      )}
    </>
  )
}
